const deferIdle = (fn, timeout = 2500) => {
  if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(fn, { timeout })
  } else {
    setTimeout(fn, 1200)
  }
}

export default deferIdle
